<template>
  <div class="app" id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
    <toast :compromise="true" />
    <loading />
    <img-viewer />
  </div>
</template>

<script>
import Toast from './components/client/Toast'
import Loading from './components/client/Loading'
import ImgViewer from './components/client/ImgViewer'
import injectGlobalHelper from './extend/injectGlobalHelper'
import vuexStore from './store'

export default {
  name: 'App',
  components: {Toast, Loading, ImgViewer},
  data () {
    return {
    }
  },
  store: vuexStore,
  created () {
    // 为了兼容一些不能设置标题栏的 WebView
    if (this.$route.query.automan_default_title) {
      document.title = this.$route.query.automan_default_title
    }

    injectGlobalHelper()

    console.log('app mounted')
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>

<style lang="stylus">
  @require '~normalize.css'
  @require 'assets/style/base.styl';
  @require 'assets/style/m-1px.styl';
  @require 'assets/style/animate.css';
  @require 'assets/style/custome-animate.css';

  // normalize();

  * {
    box-sizing: border-box;
  }

  html {
    touch-action: manipulation;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    font-family: sans-serif;
    user-select: none;
    -webkit-touch-callout: none;
    // background-color: #fff;
  }

  html.is-desktop *:not(body)::-webkit-scrollbar {
    width: 0 !important
  }

  html.is-desktop *:not(body) {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }

  // html.for-mobile body {
  //   background-color: #fff;
  // }

  html.for-mobile body .app {
    overflow-x: hidden;
  }

  html.is-fold body > .app {
    right: auto;
  }

  html.for-desktop body .app {
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
  }

  html.is-desktop body > .app-wrapper {
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    /* display: block; */
    /* width: 100%;
    height: auto; */
    min-height: 100%;
    margin: 0 auto;
  }
  html.is-desktop.for-mobile body>.app-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100%;
  }

  html.is-desktop.for-mobile .app-wrapper>.app-fixed {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    // background-color: #fff;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
    transform-origin: 0 0;
  }

  html.is-desktop.for-mobile .app-fixed>.app {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0;
    bottom: 0;
    // background-color:#f5f5f5;
  }

  .app {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
  }
</style>
